module.exports = __webpack_public_path__ + "components/flag/static/square/np-c68ff99a167e719859db6b7b5cc8ca27.svg";